export function percentage(value = 0, decimals = 2) {
  return `${Math.round((value * 100) * (10 ** decimals)) / (10 ** decimals)}%`;
}

export function percentageChartAxis(value = 0, decimals = 2) {
  return `${+((value * 100) * (10 ** decimals)).toFixed(1) / (10 ** decimals)}%`;
}
